// Auto-generated by generate-build-info.ts
export const BUILD_ID = 'build-1782274170203';
//# sourceMappingURL=build-info.js.map
